module.exports = __webpack_public_path__ + "static/media/29ADMSPC11.5749d8e4.jpg";